import gql from 'graphql-tag';

/** The short, human-readable order number shown to the shopper and on the order display. */
export const EPOS_CREATE_ORDER_EASY_ID = gql`
  mutation EposCreateOrderEasyId($venueId: String!) {
    createOrderEasyId(venueId: $venueId) {
      orderEasyId
      success
    }
  }
`;
